(ns dashboard.views.login.view
  (:require [clojure.string :as str]
            [dashboard.views.login.events :as events]
            [dashboard.views.login.subs :as subs]
            [dashboard.subs :as common-subs]
            ["react" :as react]
            ["qrcode.react" :refer [QRCodeSVG]]
            [re-frame.core :as rf]
            goog.string.format
            [goog.string :as gstring]))

(defn login-form [{:keys [initial-username]}]
  (let [[username set-username] (react/useState initial-username)
        [password set-password] (react/useState nil)
        {:keys [loading error]} @(rf/subscribe [::subs/login-form-state :login])

        submit-disabled (or loading
                            (-> username str/blank?)
                            (-> password str/blank?))]
    [:div.section>div.columns>div.column.is-two-thirds.is-offset-one-fifth
     [:p.title "Login"]
     (when error
       [:p.pb-2.has-text-danger error])
     [:form.form.p-4.login {:on-submit (fn [e]
                                         (.preventDefault e)
                                         (rf/dispatch [::events/login username password]))}
      [:div.field>p.control.has-icons-left.has-icons-right
       [:input.input {:on-change #(set-username (.. % -target -value))
                      :value username
                      :type "text"
                      :auto-complete "email"
                      :placeholder "Username"
                      :auto-focus (nil? initial-username)}]
       [:span.icon.is-small.is-left>i.fas.fa-user]
       (when-not (-> username str/blank?)
         [:span.icon.is-small.is-right>i.fas.fa-check])]
      [:div.field>p.control.has-icons-left.has-icons-right
       [:input.input {:on-change #(set-password (.. % -target -value))
                      :type "password"
                      :placeholder "Password"
                      :auto-complete "current-password"
                      :auto-focus (not (nil? initial-username))}]
       [:span.icon.is-small.is-left>i.fas.fa-lock]
       (when-not (-> password str/blank?)
         [:span.icon.is-small.is-right>i.fas.fa-check])]
      [:div.field.is-horizontal
       [:div.field-body>div.control>button.button.is-link.is-rounded {:class (when loading "is-loading")
                                                                      :type "submit"
                                                                      :disabled submit-disabled}
        "Login"]
       [:div.field-label.is-normal>label>a {:on-click #(rf/dispatch [::events/set-login-form-type :forgot-password {:username username}])
                                            :disabled submit-disabled
                                            :style {:white-space "nowrap"}}
        "Forgot password?"]]]]))

(defn forgot-password-form []
  (let [{:keys [loading username error note]} @(rf/subscribe [::subs/login-form-state :forgot-password])
        is-reset-disabled? (or loading
                               (-> username str/blank?))]
    [:div.section>div.columns>div.column.is-two-thirds.is-offset-one-fifth
     [:p.title "Reset password"]
     (when note
       [:p.pb-2 note])
     (when error
       [:p.pb-2.has-text-danger error])
     [:form.form.p-4.login {:on-submit (fn [e]
                                         (.preventDefault e)
                                         (rf/dispatch [::events/forgot-password username]))}
      [:div.field>p.control.has-icons-left.has-icons-right
       [:input.input {:value username
                      :type "text"
                      :auto-complete "username"
                      :placeholder "Username"
                      :on-change #(rf/dispatch [::events/update-login-form-values :forgot-password {:username (.. % -target -value)}])}]
       [:span.icon.is-small.is-left>i.fas.fa-user]
       ;; TODO: validate username
       (when-not (-> username str/blank?)
         [:span.icon.is-small.is-right>i.fas.fa-check])]
      [:div.field.is-horizontal
       [:div.field-body>div.control>button.button.is-link.is-rounded {:class (when loading "is-loading")
                                                                      :type "submit"
                                                                      :disabled is-reset-disabled?}
        "Reset password"]]]]))

(defn confirmation-code-valid? [code]
  (and (not (str/blank? code))
       (= (count code) 6)))

(defn confirm-forgot-password-form []
  (let [[password set-password] (react/useState nil)
        {:keys [username confirmation-code loading resend-loading delivery-medium destination error]} @(rf/subscribe [::subs/login-form-state :confirm-forgot-password])

        is-login-disabled? (or loading
                               (-> password str/blank?)
                               (not (-> confirmation-code confirmation-code-valid?)))]
    [:div.section>div.columns>div.column.is-two-thirds.is-offset-one-fifth
     [:p.title "Reset password"]
     [:p.is-success.pb-2 (case delivery-medium
                           :sms (str "A verification code has been sent to number " destination " via SMS.")
                           :email (str "A verification code has been emailed to " destination "."))]
     (when error
       [:p.pb-2.has-text-danger error])
     [:form.form.p-4.login {:on-submit (fn [e]
                                         (.preventDefault e)
                                         (rf/dispatch [::events/confirm-forgot-password username password confirmation-code]))}
      [:div.field>p.control.has-icons-left.has-icons-right
       [:input.input {:on-change #(set-password (.. % -target -value))
                      :type "password"
                      :auto-complete "password"
                      :placeholder "New password"}]
       [:span.icon.is-small.is-left>i.fas.fa-lock]
       (when-not (-> password str/blank?)
         [:span.icon.is-small.is-right>i.fas.fa-check])]
      [:div.field>p.control.has-icons-left.has-icons-right
       [:input.input {:type "text"
                      :auto-complete "one-time-code"
                      :placeholder "Verification code"
                      :value confirmation-code
                      :on-change #(rf/dispatch [::events/update-login-form-values :confirm-forgot-password {:confirmation-code (.. % -target -value)}])}]
       [:span.icon.is-small.is-left>i.fas.fa-hashtag]
       (when-not (-> confirmation-code confirmation-code-valid?)
         [:span.icon.is-small.is-right>i.fas.fa-check])]
      [:div.field.is-horizontal
       [:div.field-body>div.control>button.button.is-link.is-rounded {:class (when loading "is-loading")
                                                                      :type "submit"
                                                                      :disabled is-login-disabled?}
        "Change password"]
       [:div.field-label.is-normal>label>a {:on-click #(rf/dispatch [::events/resend-confirmation-code username])
                                            :disabled (or is-login-disabled? resend-loading)
                                            :class (when resend-loading "is-loading")
                                            :style {:white-space "nowrap"}}
        "Resend verification code"]]]]))

(defn new-password-challenge-form []
  (let [[password set-password] (react/useState nil)
        {:keys [loading error]} @(rf/subscribe [::subs/login-form-state :challenge])
        password-valid (not (str/blank? password))
        submit-disabled (or loading (not password-valid))]
    [:div.section>div.columns>div.column.is-two-thirds.is-offset-one-fifth
     [:p.title "Please set a new password"]

     (when error
       [:p.pb-2.has-text-danger error])
     [:form.form.p-4.login {:on-submit (fn [e]
                                         (.preventDefault e)
                                         (rf/dispatch [::events/respond-to-challenge {:challenge :new-password-required
                                                                                      :new-password password}]))}
      [:div.field>p.control.has-icons-left.has-icons-right
       [:input.input {:on-change #(set-password (.. % -target -value))
                      :type "password"
                      :auto-complete "password"
                      :placeholder "New password"
                      :auto-focus true}]
       [:span.icon.is-small.is-left>i.fas.fa-user]
       (when password-valid
         [:span.icon.is-small.is-right>i.fas.fa-check])]
      [:div.field.is-horizontal
       [:div.field-body>div.control>button.button.is-link.is-rounded {:class (when loading "is-loading")
                                                                      :type "submit"
                                                                      :disabled submit-disabled}
        "Set password"]]]]))

(defn code-valid? [code]
  (and (not (str/blank? code))
       (= 6 (count code))))

(defn register-mfa-form []
  (let [[code set-code] (react/useState nil)
        {:keys [loading error secret-code username]} @(rf/subscribe [::subs/login-form-state :challenge])
        code-valid (code-valid? code)
        submit-disabled (or loading (not code-valid))]
    [:div.section>div.columns>div.column.is-two-thirds.is-offset-one-fifth
     [:p.title "Setup MFA device"]

     ;; See format from https://docs.yubico.com/yesdk/users-manual/application-oath/uri-string-format.html
     [:> QRCodeSVG {:value (gstring/format "otpauth://totp/%s?secret=%s&issuer=Repliance"
                                           username
                                           secret-code)}]

     (when error
       [:p.pb-2.has-text-danger error])
     [:form.form.p-4.login {:on-submit (fn [e]
                                         (.preventDefault e)
                                         (rf/dispatch [::events/respond-to-challenge {:challenge :register-mfa
                                                                                      :user-code code}]))}
      [:div.field>p.control.has-icons-left.has-icons-right
       [:input.input {:on-change #(set-code (.. % -target -value))
                      :type "text"
                      :placeholder "Code"
                      :auto-focus true}]
       [:span.icon.is-small.is-left>i.fas.fa-user]
       (when code-valid
         [:span.icon.is-small.is-right>i.fas.fa-check])]
      [:div.field.is-horizontal
       [:div.field-body>div.control>button.button.is-link.is-rounded {:class (when loading "is-loading")
                                                                      :type "submit"
                                                                      :disabled submit-disabled}
        "Register MFA"]]]]))

(defn mfa-code-form []
  (let [[code set-code] (react/useState nil)
        {:keys [loading error]} @(rf/subscribe [::subs/login-form-state :challenge])
        code-valid (code-valid? code)
        submit-disabled (or loading (not code-valid))]
    [:div.section>div.columns>div.column.is-two-thirds.is-offset-one-fifth
     [:p.title "Provide MFA code"]

     (when error
       [:p.pb-2.has-text-danger error])
     [:form.form.p-4.login {:on-submit (fn [e]
                                         (.preventDefault e)
                                         (rf/dispatch [::events/respond-to-challenge {:challenge :mfa
                                                                                      :code code}]))}
      [:div.field>p.control.has-icons-left.has-icons-right
       [:input.input {:on-change #(set-code (.. % -target -value))
                      :type "text"
                      :placeholder "Code"
                      :auto-focus true}]
       [:span.icon.is-small.is-left>i.fas.fa-user]
       (when code-valid
         [:span.icon.is-small.is-right>i.fas.fa-check])]
      [:div.field.is-horizontal
       [:div.field-body>div.control>button.button.is-link.is-rounded {:class (when loading "is-loading")
                                                                      :type "submit"
                                                                      :disabled submit-disabled}
        "Submit"]]]]))

(defn challenge-form []
  (let [{:keys [challenge]} @(rf/subscribe [::subs/login-form-state :challenge])]
    (case challenge
      :new-password-required [:f> new-password-challenge-form]
      :register-mfa [:f> register-mfa-form]
      :register-mfa-success [:f> login-form {:initial-username (:username @(rf/subscribe [::subs/login-form-state :login]))}]
      :mfa [:f> mfa-code-form]
      nil)))

(defn login-page []
  (let [{:keys [type]} @(rf/subscribe [::subs/login-form])
        route-parameters @(rf/subscribe [::common-subs/route-parameters])
        mode (get-in route-parameters [:query :mode])]
    [:div {:class (when (= mode "embed") "pt-6")}
     (case type
       :login [:f> login-form]
       :forgot-password [forgot-password-form]
       :confirm-forgot-password [:f> confirm-forgot-password-form]
       :challenge [challenge-form]
       (println "unhandled form type: " type))]))
